import Vue from 'vue'
import Router from 'vue-router'
import Login from './../views/login.vue'
import NotFound from './../views/404.vue'
import Home from './../views/home.vue'

Vue.use(Router)
const UserCompany = resolve => {
  require(['./../views/user_central/user_company_v3.vue'], resolve)
}
const UserPerson = resolve => {
  require(['../views/user_central/user_person_v3.vue'], resolve)
}
const SearchCompany = resolve => {
  require(['./../views/search/search_company.vue'], resolve)
}
const SearchPerson = resolve => {
  require(['./../views/search/search_person.vue'], resolve)
}

const IndexModel = resolve => {
  require(['./../views/home/index_company.vue'], resolve)
}
const IndexPersonModel = resolve => {
  require(['./../views/home/index_person.vue'], resolve)
}
const forgotPassword = resolve => {
  require(['./../views/forgot-password.vue'], resolve)
}
const companyDetail = resolve => {
  require(['./../views/search/company-details.vue'], resolve)
}
//用户中心
const MemberIndex = resolve => {
  require(['./../views/member/index.vue'], resolve)
}
//企业圈子
const MemberCompany = resolve => {
  require(['./../views/member/company-circle.vue'], resolve)
}
//企业圈子
const authResult = resolve => {
  require(['./../views/member/auth-result.vue'], resolve)
}
//商圈邀请
const MemberInvitation = resolve => {
  require(['./../views/member/invitation.vue'], resolve)
}
//计费中心
const MemberAccount = resolve => {
  require(['./../views/member/account.vue'], resolve)
}

//消息列表
const MemberMessage = resolve => {
  require(['./../views/member/message.vue'], resolve)
}
//消息详情
const MessageInfo = resolve => {
  require(['../views/member/message-info.vue'], resolve)
}
// 我的D币
const MyDB = resolve => {
  require(['../views/member/my-DB.vue'], resolve)
}
//企业服务
const MemberService = resolve => {
  require(['./../views/member/member_service.vue'], resolve)
}
const MemberProfile = resolve => {
  require(['./../views/member/profile.vue'], resolve)
}
const MemberPassword = resolve => {
  require(['./../views/member/password.vue'], resolve)
}
const RegisterTip = resolve => {
  require(['./../views/common/register-tip.vue'], resolve)
}
const PayPage = resolve => {
  require(['./../views/common/pay_page.vue'], resolve)
}
const Plan = resolve => {
  require(['./../views/member/member_service.vue'], resolve)
}
const Package = resolve => {
  require(['../views/home/package.vue'], resolve)
}
const PersonDetails = resolve => {
  require(['./../views/search/person-details.vue'], resolve)
}
//征信报告
const CreditReport = resolve => {
  require(['./../views/search/credit_report.vue'], resolve)
}

// 征信报告模块
// 搜国内列表
const SearchCnCompany = () => import('@/views/search/search_cnCompany')
// 国内列表详情
const inlandDetail = () => import('@/views/search/inland_detail')
// 征信报告首页
const credit = () => import('./../views/home/index_credit.vue')
// 报告确认页
const standardOrder = () => import('@/views/credit_report/standard_order')
// 关联报告确认页
const relevanceReport = () => import('@/views/credit_report/relevance_report')
// 海外报告确认页
const overseasReport = () => import('@/views/credit_report/overseas_order')

// 我的报告
const myReport = () => import('@/views/member/myReport')
// 我的报告详情
const reportDetail = () => import('@/views/member/reportDetail')
// 我的流量包详情
const packageDetail = () => import('@/views/member/packageDetail')

const jumpregister = () => import('@/views/jumpregister.vue')

const Abstract = () => import('@/views/home/abstract.vue')

const Privacy = () => import('@/views/home/privacy.vue')


// 社交图谱列表页
const socialGraph = () => import('@/views/search/social-graph')

const socialGraphDetail = () => import('@/views/search/social-graph-detail')
//设置路由
let routes = [
  // {
  //     path: '/',
  //     component: Login,
  //     name: '',
  //     hidden: true
  // },
  {
    path: '/mine/package-pay-success',
    redirect: {
      path: '/member/account',
    },
  },
  {
    path: '/page',
    component: PayPage,
    name: 'page',
    hidden: true,
  },
  {
    path: '/forgotPassword',
    component: forgotPassword,
    name: '',
    hidden: true,
  },
  {
    path: '/login',
    component: Login,
    name: '',
    hidden: true,
    meta: {
      isLogin: true,
    },
  },
  {
    path: '/login/:invitedId',
    component: Login,
    name: '登录2',
    hidden: true,
    meta: {
      isLogin: true,
    },
  },
  {
    path: '/404',
    component: NotFound,
    name: '',
    hidden: true,
  },
  {
    path: '*',
    hidden: true,
    redirect: {
      path: '/404',
    },
  },
  {
    path: '/',
    component: Home,
    iconCls: 'iconfont icon-users',
    meta: {
      requireAuth: false,
    },
    children: [
      {
        path: '/',
        component: IndexModel,
        name: '首页',
        meta: {
          requireAuth: false,
          menuIndex: 'search_company',
          ismin: false,
          hideHead: false,
          isIndex: true,
        },
        children: [],
      },
      // {
      //   path: '/abstract',
      //   component: Abstract,
      //   name: '简介页',
      //   meta: {
      //     isIndex: false,
      //     isHigh: true,
      //     bgcF: true,
      //     keepAlive: true
      //   },
      // },
      {
        path: '/privacy',
        component: Privacy,
        name: '隐私条款',
        meta: {
          isIndex: false,
          isHigh: true,
          bgcF: true,
          keepAlive: true
        },
      },
      {
        path: '/jumpregister',
        component: jumpregister,
        name: '空白页',
        meta: {
          hideHead: true,
        },
      },
      // {
      //   path: '/person',
      //   component: IndexPersonModel,
      //   name: '搜联系人',
      //   meta: {
      //     requireAuth: false,
      //     menuIndex: 'search_person',
      //     ismin: false,
      //     hideHead: false,
      //     isIndex: true,
      //   },
      //   children: [],
      // },
      // {
      //   path: '/credit',
      //   component: credit,
      //   name: 'credit',
      //   meta: {
      //     menuIndex: 'search_credit',
      //     isIndex: false,
      //   },
      // },
      {
        path: '/register_tip',
        component: RegisterTip,
        name: '邮箱注册',
        meta: {
          requireAuth: false,
          menuIndex: 'user_company',
          keepAlive: false,
          ismin: false,
          hideHead: false,
        },
      },
      // {
      //   path: '/plan',
      //   component: Plan,
      //   name: '',
      //   meta: {
      //     requireAuth: false,
      //     menuIndex: 'plan',
      //   },
      // },
      {
        path: '/package',
        component: Package,
        name: '',
        meta: {
          requireAuth: false,
          menuIndex: 'package',
        },
      },
    ],
  },
  {
    path: '/',
    component: Home,
    iconCls: 'iconfont icon-users',
    meta: {
      requireAuth: false,
    },
    children: [
      {
        path: '/user_central/company',
        component: UserCompany,
        name: '公司',
        meta: {
          requireAuth: false,
          menuIndex: 'user_company',
          ismin: false,
          hideHead: false,
          self_name: 'D059',
          crumbs: [{ path: '/user_central/person', p_name: 'D205' }],
        },
      },
      {
        path: '/user_central/person',
        component: UserPerson,
        name: '我的联系人',
        meta: {
          requireAuth: false,
          menuIndex: 'user_company',
          ismin: false,
          hideHead: false,
          self_name: 'D058',
          crumbs: [{ path: '/user_central/person', p_name: 'D205' }],
        },
      },
      {
        path: '/user_central/company-details/:id',
        component: companyDetail,
        name: '我的公司详情',
        meta: {
          requireAuth: false,
          menuIndex: 'user_company',
          ismin: false,
          hideHead: true,
        },
      },
      // {
      //     path: '/login/:invitedId',
      //     component: Login,
      //     name: '登录2',
      //     meta: {
      //         requireAuth: false,
      //         menuIndex:'user_company',
      //         ismin:false,
      //         hideHead:false,
      //         isLogin:true,
      //     },
      // }
    ],
  },
  {
    path: '/',
    component: Home,
    iconCls: 'iconfont icon-users',
    meta: {
      requireAuth: false,
    },
    children: [
      {
        path: '/search/cn-company',
        component: SearchCnCompany,
        name: '公司搜索',
        meta: {
          requireAuth: false,
          menuIndex: 'search_company',
          keepAlive: true,
          ismin: false,
          hideHead: false,
          self_name: '_F29BF0DACABC8ED2',
          crumbs: [{ path: '/', p_name: 'D001' }],
        },
      },
      // {
      //   path: '/search/inland-detail/:id',
      //   component: inlandDetail,
      //   name: 'inlandDetail',
      //   meta: {
      //     requireAuth: false,
      //     menuIndex: 'search_company',
      //     ismin: false,
      //     keepAlive: true,
      //     hideHead: true,
      //     self_name: '_2D59C19603FD5527', // 面包屑当前
      //     crumbs: [
      //       { path: '/', p_name: 'D001' },
      //       { path: '/search/cn-company', p_name: '_F29BF0DACABC8ED2' },
      //     ], // 面包屑父级
      //   },
      // },
      {
        path: '/search/social-graph',
        component: socialGraph,
        name: '社交图谱',
        meta: {
          requireAuth: false,
          menuIndex: 'social_graph',
          keepAlive: true,
          ismin: false,
          hideHead: false,
          self_name: '社交图谱',
          crumbs: [{ path: '/', p_name: 'D001' }],
        },
      },
      {
        path: '/search/social-graph-detail',
        component: socialGraphDetail,
        name: '社交图谱详情',
        meta: {
          requireAuth: false,
          menuIndex: 'social_graph',
          keepAlive: false,
          ismin: false,
          hideHead: true,
          self_name: '_1B52E217C72A9BE8',
          crumbs: [
            {path: '/search/social-graph', p_name: '_4EA87CA412FA79DF'}
          ],
        },
      },
      {
        path: '/search/company',
        component: SearchCompany,
        name: '公司搜索',
        meta: {
          crawler: true, // 被爬虫
          requireAuth: false,
          menuIndex: 'search_company',
          keepAlive: true,
          ismin: false,
          hideHead: false,
          self_name: '_591EB3EC5759E4B0',
          crumbs: [{ path: '/', p_name: 'D001' }],
        },
      },
      {
        path: '/search/company-details/:id',
        component: companyDetail,
        name: '公司详情',
        meta: {
          crawler: true, // 被爬虫
          requireAuth: false,
          menuIndex: 'search_company',
          ismin: false,
          hideHead: true,
          self_name: '_DC806EEC155CA5F0',
          crumbs: [
            { path: '/', p_name: 'D001' },
            { path: '/search/company', p_name: 'D026' },
          ],
        },
      },
      {
        path: '/search/person-details/:id',
        component: PersonDetails,
        name: '联系人详情',
        meta: {
          crawler: true, // 被爬虫
          requireAuth: false,
          menuIndex: 'search_person',
          ismin: false,
          hideHead: true,
          self_name: 'D202',
          crumbs: [
            { path: '/search/person', p_name: 'D046' },
          ],
        },
      },
      {
        path: '/search/person',
        component: SearchPerson,
        name: '联系人搜索',
        meta: {
          crawler: true, // 被爬虫
          requireAuth: false,
          menuIndex: 'search_person',
          keepAlive: true,
          ismin: false,
          hideHead: false,
          self_name: 'D046',
          crumbs: [{ path: '/person', p_name: 'D204' }],
        },
      },
      // {
      //   path: '/search/credit/:id',
      //   component: CreditReport,
      //   name: '征信报告',
      //   meta: {
      //     requireAuth: false,
      //     menuIndex: 'search_credit',
      //     keepAlive: false,
      //     self_name: 'D008',
      //     crumbs: [
      //       { path: '/', p_name: 'D001' },
      //       { path: '/search/company', p_name: 'D026' },
      //       { path: '/search/company-details/id', p_name: 'D032' },
      //     ],
      //   },
      // },
    ],
  },
  {
    path: '/',
    component: Home,
    name: '',
    hidden: true,
    meta: {
      requireAuth: true,
    },
    children: [
      {
        path: '/member',
        component: MemberIndex,
        name: '',
        meta: {
          self_name: '',
          crumbs: [],
        },
        children: [
          // {
          //   path: 'company-circle',
          //   component: MemberCompany,
          //   name: '企业圈子',
          //   meta: {
          //     requireAuth: true,
          //     menuIndex: 'company-circle',
          //     ismin: false,
          //     hideHead: false,
          //     isPd: true,
          //     self_name: '_7F28764B786320F9',
          //     crumbs: [{ path: '', p_name: 'D416' }],
          //   },
          // },
          // {
          //   path: 'auth-result',
          //   component: authResult,
          //   name: '企业圈子',
          //   meta: {
          //     requireAuth: true,
          //     menuIndex: 'company-circle',
          //     ismin: false,
          //     hideHead: false,
          //     isPd: true,
          //     self_name: '_7F28764B786320F9',
          //     crumbs: [{ path: '', p_name: 'D416' }],
          //   },
          // },
          // {
          //   path: 'invitation',
          //   component: MemberInvitation,
          //   name: '商圈邀请',
          //   meta: {
          //     requireAuth: true,
          //     menuIndex: 'invitation',
          //     ismin: false,
          //     hideHead: false,
          //     isPd: true,
          //     self_name: 'D062',
          //     crumbs: [{ path: '', p_name: 'D416' }],
          //   },
          // },
          {
            path: 'account',
            component: MemberAccount,
            name: '计费中心',
            meta: {
              requireAuth: true,
              menuIndex: 'account',
              ismin: false,
              hideHead: false,
              isPd: true,
              self_name: '_087FA94C1AFFC0E0',
              crumbs: [{ path: '', p_name: 'D416' }],
            },
          },
          {
            path: 'profile',
            component: MemberProfile,
            name: '修改个人信息',
            meta: {
              requireAuth: true,
              menuIndex: 'profile',
              ismin: false,
              hideHead: false,
              isPd: true,
              self_name: 'D070',
              crumbs: [{ path: '', p_name: 'D416' }],
            },
          },
          {
            path: 'password',
            component: MemberPassword,
            name: '修改密码',
            meta: {
              requireAuth: true,
              menuIndex: 'password',
              ismin: false,
              hideHead: false,
              isPd: true,
              self_name: 'D070',
              crumbs: [{ path: '', p_name: 'D416' }],
            },
          },
          // {
          //   path: 'message',
          //   component: MemberMessage,
          //   name: '消息中心',
          //   meta: {
          //     requireAuth: true,
          //     menuIndex: 'message',
          //     ismin: false,
          //     hideHead: false,
          //     isPd: true,
          //     self_name: 'D073',
          //     crumbs: [{ path: '', p_name: 'D416' }],
          //   },
          // },
          {
            path: 'myreport',
            component: myReport,
            name: '我的报告',
            meta: {
              requireAuth: true,
              menuIndex: 'myreport',
              ismin: false,
              hideHead: false,
              isPd: true,
              self_name: '_F967257B46C4AC73',
              crumbs: [{ path: '', p_name: 'D416' }],
            },
          },
          {
            path: 'reportDetail/:id',
            component: reportDetail,
            name: '我的订单',
            meta: {
              requireAuth: true,
              menuIndex: 'myreport',
              ismin: false,
              hideHead: false,
              isPd: true,
              self_name: '_F967257B46C4AC73',
              crumbs: [{ path: '', p_name: 'D416' }],
            },
          },
          {
            path: 'packageDetail/:id',
            component: packageDetail,
            name: '我的订单',
            meta: {
              requireAuth: true,
              menuIndex: 'myreport',
              ismin: false,
              hideHead: false,
              isPd: true,
              self_name: '_F967257B46C4AC73',
              crumbs: [{ path: '', p_name: 'D416' }],
            },
          },
          // {
          //   path: 'member-service',
          //   component: MemberService,
          //   name: '会员服务',
          //   meta: {
          //     requireAuth: true,
          //     menuIndex: 'member-service',
          //     ismin: false,
          //     hideHead: false,
          //     isPd: true,
          //   },
          // },
          // {
          //   path: 'message-info/:id',
          //   component: MessageInfo,
          //   name: '消息详情',
          //   meta: {
          //     requireAuth: true,
          //     menuIndex: 'message-info',
          //     ismin: false,
          //     hideHead: false,
          //     isPd: true,
          //     self_name: 'D381',
          //     crumbs: [
          //       { path: '', p_name: 'D416' },
          //       { path: '/member/message', p_name: 'D073' },
          //     ],
          //   },
          // },
          // {
          //   path: 'my-db',
          //   component: MyDB,
          //   name: '我的D币',
          //   meta: {
          //     requireAuth: true,
          //     menuIndex: 'my-db',
          //     ismin: false,
          //     hideHead: false,
          //     isPd: true,
          //     self_name: '_CEC257C6291C92B6',
          //     crumbs: [{ path: '', p_name: 'D416' }],
          //   },
          // },
        ],
      },
    ],
  },
  {
    path: '/',
    component: Home,
    name: '',
    hidden: true,
    meta: {
      requireAuth: true,
    },
    children: [
      // {
      //   path: '/standard-order',
      //   component: standardOrder,
      //   name: '标准订单',
      //   meta: {
      //     menuIndex: 'search_credit',
      //     self_name: 'creditReport',
      //     crumbs: [{ path: '/credit', p_name: '_908BA8F840F48F54' }],
      //   },
      // },
      // {
      //   path: '/relevance-report',
      //   component: relevanceReport,
      //   name: '关联报告',
      //   meta: {
      //     menuIndex: 'search_credit',
      //     self_name: 'creditReport',
      //     crumbs: [{ path: '/credit', p_name: '_908BA8F840F48F54' }],
      //   },
      // },
      // {
      //   path: '/overseas-report',
      //   component: overseasReport,
      //   name: '海外报告',
      //   meta: {
      //     menuIndex: 'search_credit',
      //     self_name: 'creditReport',
      //     crumbs: [{ path: '/credit', p_name: '_908BA8F840F48F54' }],
      //   },
      // },
    ],
  },
]
export default routes



// WEBPACK FOOTER //
// ./src/router/index.js